import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'complete-task-custom', [
  'START',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'todo',
  type: 'put',
  slug: [
    'users',
    {
      type: 'payload',
      selector: ['user_id'],
    },
    'custom_tasks',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/complete-task-custom-req.js